<template>

    <div>

        <div class="form-row mb-1">
            <div class="col">
                <input type="file" class="form-control" @change="onFileChange">
            </div>
            <div class="col" v-if="handler">
                <img :src="handler">
                <span class="close" @click="removeImage">&times;</span>
            </div>
        </div>
        <div class="form-row">
            <div class="col">
                <label>{{_lang('Color','input')}}</label>
                <color-picker v-model="color" @change="inputColor" />
            </div>
            <div class="col">
                <label>{{_lang('Position','input')}}</label>
                <select v-model="position" class="form-control" @change="change">
                    <option value="center">center</option>
                    <option value="left center">left center</option>
                    <option value="right center">right center</option>
                    <option value="top center">top center</option>
                    <option value="bottom center">bottom center</option>
                    <option value="top left">top left</option>
                    <option value="top right">top right</option>
                    <option value="bottom left">bottom left</option>
                    <option value="bottom right">bottom right</option>
                </select>
            </div>
        </div>
    </div>

</template>
<style scoped>
.close {
    position: absolute;
    top: 0;
    z-index: 2;
    right: 10px;
    background: #fff;
    border-radius: 50px;
    width: 1.5rem;
    text-align: center;
    cursor: pointer;
}

</style>

<script>
import axios from 'axios';
import ColorPicker from './ColorPicker';

export default {
  props: ['config', 'name', 'value'],
  components:{
      'color-picker':ColorPicker,
  },
  data(){
      return {
          handler:'',
          color:'#f1f1f1',
          repeat:'no-repeat',
          position:'center',

      }
  },
  mounted(){
      if(!this.value) return;
      var match = this.value.match(/url\(['"]?([^)]+?)['"]?\)/);
      if(match){
          this.handler = match[1];
          this.type = 'image';

          match = this.value.match(/(#[0-9a-f]+|rgba\([^)]+?\))/i)
          if(match) this.color = match[1];

          match = this.value.match(/\b((?:top|right|bottom|left|center)(?: (?:top|right|bottom|left|center))?)\b/i)
          if(match) this.position = match[1];
      }

  },
  methods:{
      removeImage(){
          this.handler = '';
          this.$emit('change','');
      },
    inputColor(newcolor){
      this.color = newcolor;
      this.change();
    },
    change(newval){
        newval = `url(${this.handler}) no-repeat ${this.position}`;
        if(this.color) newval += ' '+this.color;
        this.$emit('change',newval);

    },

    onFileChange(event,field){
        var files = event.target.files || event.dataTransfer.files;

        var file = files[0];
        if(!file) return;
        event.target.value='';

        var reader = new FileReader();
        reader.onload = (e) => {
            var base64 =  e.target.result;
            var data = {
                name:file.name,
                content:base64
            }

            axios.post('/api/upload',data).then((response)=> {
                this.handler = response.data;
                this.change();
            }).catch((error) =>  {
                console.error(error);
                if(error.response) alert(error.response.data);
            })

        }
        reader.readAsDataURL(file);
    }

  }

}
</script>
